
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/gmm",
      function () {
        return require("private-next-pages/gmm.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/gmm"])
      });
    }
  